import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  AppBar, Box, Toolbar, Button, makeStyles,Container,
  Drawer,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import 'src/assets/scss/psaCustomCss.css';
import Logo from './Logo'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { components } from 'cng-web-lib'
import '../../../assets/scss/psaCustomCss.css';

const {
  button: { CngButton }
} = components

const useStyles = makeStyles((theme) => ({
   appBar: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary
  },
  toolbar: {
    backgroundColor: theme.palette.common.white,
    height: 64,
    paddingLeft: 0,
    '& > .header-left': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  logo: {
    margin: '0 16px 0 0 !important'
  },
  link: {
  backgroundColor: '#f3a73e', 
  borderRadius: 999,
  boxShadow: 'none',
  color: '#FFFFFF',  
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.2,
  minHeight: 'unset',
  textTransform: 'none',
  fontFamily: '"Asap", sans-serif',

  '&:hover': {
    backgroundColor: '#d98f1f', 
    boxShadow: `0px 3px 7px rgba(0, 0, 0, 0.08),
      0px 6px 12px -2px rgba(0, 0, 0, 0.09),
      0px 15px 32px -3px rgba(0, 0, 0, 0.1)`
  },

  '&:focus': {
    backgroundColor: '#d98f1f'
  },

  '&:active': {
    backgroundColor: '#a66a12' 
  },

  '& + &': {
    marginLeft: theme.spacing(2)
  }
}
}))
function TopBar({ className, ...rest }) {
  const classes = useStyles()
  const theme = useTheme()
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'))
  
  return (
    <AppBar className={clsx(className, classes.appBar)} {...rest}>
      <Container>
        <Toolbar className={classes.toolbar}>
          <Box className='header-left'>
            <RouterLink to='/psa' style={{ display: 'flex' }}>
              <Logo className={classes.logo} />
            </RouterLink>
          </Box>
          <Box flexGrow={1} />
		  {!xsDown ? (
			  <Box>
				  <CngButton
					  className={classes.link}
					  component={RouterLink}
					  to='/login'
				  >
					  Login
				  </CngButton>
			  </Box>
		  ) : (
            <Drawer variant='permanent' anchor='bottom'>
              <Box display='flex' justifyContent='center' p={2}>
                <CngButton
                  className={classes.link}
                  component={RouterLink}
                  to='/login'
                >
                  Login
                </CngButton>
              </Box>
            </Drawer>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  )
}

TopBar.propTypes = {
  className: PropTypes.string
}

export default TopBar
